// Enable/disable initials field based on Customization option selection
document.addEventListener('DOMContentLoaded', function() {
  const variantSelectors = document.querySelectorAll('[name="Customization"]');
  const initialsInput = document.querySelector('[data-initials-input]');
  
  if (!initialsInput || variantSelectors.length === 0) return;

  function toggleInitialsField() {
    const selectedValue = document.querySelector('[name="Customization"]:checked')?.value || 
                         document.querySelector('select[name="Customization"]')?.value;
    
    const isCustomizationSelected = selectedValue && 
                                   selectedValue.toLowerCase() !== 'options' &&
                                   (selectedValue.toLowerCase().includes('gold') || 
                                    selectedValue.toLowerCase().includes('embossing'));
    
    if (isCustomizationSelected) {
      initialsInput.disabled = false;
      initialsInput.style.opacity = '1';
      initialsInput.style.cursor = 'text';
      initialsInput.style.backgroundColor = '';
      
      if (initialsInput.dataset.required === 'true') {
        initialsInput.setAttribute('required', 'required');
        initialsInput.setAttribute('aria-required', 'true');
      }
    } else {
      initialsInput.disabled = true;
      initialsInput.style.opacity = '0.5';
      initialsInput.style.cursor = 'not-allowed';
      initialsInput.style.backgroundColor = '#f5f5f5';
      initialsInput.value = '';
      
      initialsInput.removeAttribute('required');
      initialsInput.removeAttribute('aria-required');
    }
  }

  variantSelectors.forEach(selector => {
    selector.addEventListener('change', toggleInitialsField);
  });

  toggleInitialsField();
});
